"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var New = function New(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.943 2.984H7.227A1.95 1.95 0 005.28 4.932v7.716a1.95 1.95 0 001.948 1.948h7.716a1.95 1.95 0 001.948-1.948V4.932a1.95 1.95 0 00-1.948-1.948zm.836 9.664c0 .46-.376.836-.836.836H7.227a.836.836 0 01-.836-.836V4.932c0-.46.376-.836.836-.836h7.716c.46 0 .836.376.836.836v7.716z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 15.496a.935.935 0 01-.773.412h-7.76a.697.697 0 01-.696-.696V7.448a.93.93 0 01.412-.772.558.558 0 00.148-.772.554.554 0 00-.772-.148c-.564.38-.9 1.012-.9 1.692v7.764c0 .996.812 1.804 1.808 1.804h7.764c.68 0 1.312-.336 1.692-.9a.558.558 0 00-.148-.772.567.567 0 00-.776.152zM13.712 8.236H11.64V6.164a.555.555 0 10-1.112 0v2.072H8.456a.555.555 0 100 1.112h2.072v2.072a.555.555 0 101.112 0V9.348h2.072a.555.555 0 100-1.112z",
    fill: color
  }));
};
var _default = exports["default"] = New;